import EcoEmail from 'eco-design/elements/eco-email';
import EcoBanner, { EcoBannerProps } from 'eco-design/sections/eco-banner-card';
import { useMemo } from 'react';
import EcoIconArrow from 'eco-design-micro/icons/eco-icon-arrow';
import moment from 'moment';
import { textTran } from 'eco-design/elements/eco-email/config';
import { useWebpOrJpg } from '../../hooks/useWebpOrJpg';
import css from './index.module.scss';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/i18n';
import { useGlobal } from '@/utils/useGlobal';

const contactListIds = {
    jp: '941861642',
};

function BannerEmailB() {
    const { t } = useLang('theProductV2.Banner');
    const { getSystemTime } = useGlobal();
    const { locale = 'jp' } = getLocal();
    const fields = useMemo(() => {
        const date = moment(getSystemTime()).format('YYYY-MM-DD');
        return [
            { type: 'single', id: '4431', value: 1, overwrite: true },
            { type: 'single', id: '31', value: 1, overwrite: true },
            { type: 'multiple', id: '12713', value: [3], overwrite: false },
            { type: 'text', id: '12712', value: date, overwrite: false },
        ];
    }, [getSystemTime]);
    const textObj = textTran[locale] || textTran['jp'];
    return (
        <div className="email-hot-box">
            <EcoEmail
                contactListId={[contactListIds[locale as keyof typeof contactListIds] ?? contactListIds.jp]}
                source="WEB_NEW_PRODUCT_SUB"
                fields={fields}
                termsHtml={
                    locale === 'jp'
                        ? `EcoFlow の<a href="https://account.ecoflow.com/agreement/ja-jp/PrivacyPolicy.html" target="_blank">プライバシーポリシー</a>と<a href="https://account.ecoflow.com/agreement/ja-jp/TermsOfUse.html" target="_blank">利用規約</a>に同意します`
                        : undefined
                }
                tipsObj={{
                    placeholder: t('emailPlaceholder'),
                }}
                dataLayer={{
                    event: 'uaEvent',
                    event_name: 'activity_submit',
                    button_name: textObj.btnText,
                    product_name: 'EcoFlow RAPID Mag',
                }}
                subscribeData={{
                    sector_name: t('title'),
                    entry_position: 1,
                }}
            />
        </div>
    );
}
export default function Comp() {
    const { t } = useLang('theProductV2.Banner');
    const { t: t2 } = useLang('theProductV2');
    const webpOrJpg = useWebpOrJpg('#rapid-mag-Banner-V2');

    const dataA: EcoBannerProps = {
        layout: 'top-center',
        pc: webpOrJpg('https://websiteoss.ecoflow.com/upload/image/1761272275904/pc.jpg', 'https://websiteoss.ecoflow.com/upload/image/1761707278212/pc.webp'),
        pad: webpOrJpg(
            'https://websiteoss.ecoflow.com/upload/image/1761272275317/pad.jpg',
            'https://websiteoss.ecoflow.com/upload/image/1761707277856/pad.webp',
        ),
        h5: webpOrJpg('https://websiteoss.ecoflow.com/upload/image/1761272275524/h5.jpg', 'https://websiteoss.ecoflow.com/upload/image/1761707277610/h5.webp'),
        label: t('label'),
        title: t('title'),
        desc: t('desc'),

        lChildren: (
            <span>
                {t('buynow')}
                <EcoIconArrow />
            </span>
        ),
        lType: 'text',
        lHref: '#PowerSolution',
        lDataLayer: {
            event: 'uaEvent',
            event_name: 'click_anchor',
            position: t2('PowerSolution.title'),
            button_name: t('buynow'),
        },
        rChildren: t('video'),
        rType: 'text',
        rHref: 'https://www.youtube.com/embed/vZSL4lCez18',
        rBtnIsYouToBe: true,

        childrenB: <BannerEmailB />,
        theme: 'black',
    };
    return (
        <section
            className={`${css.section} GtmModuleData-section`}
            id="rapid-mag-Banner-V2"
            data-section-id={'rapid-mag-Banner-V2'}
            data-section-title={t('title')}
        >
            <EcoBanner {...dataA} />
        </section>
    );
}
